import { apiFetch } from "./client";

export type ApiKeyType = "secret" | "publishable";
export type ApiKeyEnvironment = "test" | "live";
export type ApiKeyScope = "full" | "restricted";

export interface CreateApiKeyInput {
  type: ApiKeyType;
  environment: ApiKeyEnvironment;
  scope?: ApiKeyScope;
  label?: string;
}

export interface ApiKey {
  id: string;
  type: ApiKeyType;
  environment: ApiKeyEnvironment;
  prefix: string;
  scope: ApiKeyScope;
  label: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

export interface CreatedApiKey {
  id: string;
  prefix: string;
  // El gateway sólo devuelve el secret completo en la creación inicial — esta es la
  // única oportunidad para mostrárselo al admin para que lo copie.
  secret: string;
  type: ApiKeyType;
  environment: ApiKeyEnvironment;
  scope?: ApiKeyScope;
  label?: string | null;
  createdAt: string;
}

export interface CreatedApiKeyPair {
  secret: CreatedApiKey;
  publishable: CreatedApiKey;
}

export const listApiKeys = (merchantId: string) =>
  apiFetch<ApiKey[]>(`/admin/merchants/${merchantId}/api-keys`);

export const bootstrapApiKey = (merchantId: string, body: CreateApiKeyInput) =>
  apiFetch<CreatedApiKey>(`/admin/merchants/${merchantId}/api-keys`, {
    method: "POST",
    body,
  });

export const generateApiKeyPair = (
  merchantId: string,
  body: { environment: ApiKeyEnvironment; label?: string },
) =>
  apiFetch<CreatedApiKeyPair>(`/admin/merchants/${merchantId}/api-keys/pair`, {
    method: "POST",
    body,
  });

export const revokeApiKey = (merchantId: string, id: string) =>
  apiFetch<void>(`/admin/merchants/${merchantId}/api-keys/${id}`, {
    method: "DELETE",
  });
